module.exports = __webpack_public_path__ + "static/media/flight_ticket_2.3faa7db5.svg";